var _style, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#E5E5E5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M600,0C268.9,0,0,268.9,0,600c0,331.2,268.9,600,600,600c331.2,0,600-268.9,600-600S931.1,0,600,0z  M527.7,463.3L665,600.6L528.9,736.7c-23.5,23.4-23.5,61.4,0,84.8c23.4,23.5,61.4,23.5,84.8,0L792.3,643c23.4-23.5,23.4-61.4,0-84.9 L612.6,378.5c-23.5-23.5-61.4-23.5-84.9,0C504.3,401.9,504.3,439.9,527.7,463.3L527.7,463.3z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.6673f82dae60572b65ad29b47596d18e.svg";
export { ForwardRef as ReactComponent };